import { render, staticRenderFns } from "./CuentasPorPagar.vue?vue&type=template&id=a793428e&"
import script from "./CuentasPorPagar.vue?vue&type=script&lang=js&"
export * from "./CuentasPorPagar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports